import { Action } from 'redux';

export { isLoading, doneLoading } from 'store/config/actions';

// --- Action Types ---

// Get all
export const GET_PERSON_PROPERTIES = 'optional-properties/GET_PERSON_PROPERTIES';
export interface GetPersonPropertiesAction extends Action<typeof GET_PERSON_PROPERTIES> {
  readonly type: typeof GET_PERSON_PROPERTIES;
}

// Update person properties
export const PERSIST_PERSON_PROPERTIES = 'optional-properties/PERSIST_PERSON_PROPERTIES';
export interface PersistPersonPropertiesAction extends Action<typeof PERSIST_PERSON_PROPERTIES> {
  readonly type: typeof PERSIST_PERSON_PROPERTIES;
  readonly payload: OptionalProperties;
}

export const SAVE_PERSON_PROPERTIES = 'optional-properties/SAVE_PERSON_PROPERTIES';
export interface SavePersonPropertiesAction extends Action<typeof SAVE_PERSON_PROPERTIES> {
  readonly type: typeof SAVE_PERSON_PROPERTIES;
  readonly payload: OptionalProperties;
}

export type PersonPropertiesAction =
  GetPersonPropertiesAction | PersistPersonPropertiesAction | SavePersonPropertiesAction;

// --- Actions ---

export const getPersonProperties = (): GetPersonPropertiesAction => ({
  type: GET_PERSON_PROPERTIES,
});

export const persistPersonProperties = (properties: OptionalProperties): PersistPersonPropertiesAction => ({
  type: PERSIST_PERSON_PROPERTIES,
  payload: properties,
});

export const savePersonProperties = (properties: OptionalProperties): SavePersonPropertiesAction => ({
  type: SAVE_PERSON_PROPERTIES,
  payload: properties,
});
